import mqtt from 'mqtt'
import { uuidv5 } from './util.js'
let env = 'dev'
if (process.env.NODE_ENV === 'production') {
  env = 'prod'
}
if (process.env.NODE_ENV === 'test') {
  env = 'test'
}
const clientId = 'mqttjs_' + uuidv5()
const defaultOptions = {
  connection: {
    protocolId: 'MQTT',
    protocolVersion: 4, // MQTT连接协议版本
    host: 'mqtt.ayundi.cn',
    // host: 'custom-pre.ayundi.cn:1443',
    port: 443,
    endpoint: '/mqtt',
    clean: false, // true 创建一个新的临时会话  false 创建一个持久会话
    connectTimeout: 300 * 1000, // 超时时间
    reconnectPeriod: 1000, // 重连时间间隔
    // 认证信息
    clientId,
    username: 'admin',
    password: 'ayd@123'
  },
  subscription: {
    qos: 0
  },
  publish: {
    qos: 0
  },
  receiveNews: '',
  // 全局唯一一个连接
  client: {
    connected: false
  },
  subscribeSuccess: false,
  tempSubxcriptionArr: [], // 临时存储通道打开前的订阅
  subscribeList: [], // 存储所有的订阅
  loading: false // 连接中
}
const getPrefix = () => {
  const subEnv = {
    dev: 'debug',
    test: 'debug',
    prod: 'prod'
  }
  return subEnv[env]
}

const doSubscribe = (topic, onChange, options) => {
  if (!topic) {
    return
  }
  const qos = options && options.qos ? options.qos : defaultOptions.subscription.qos
  const prefix = getPrefix() + ':'
  const realTopic = prefix + topic
  if (!defaultOptions.client.connected) {
    defaultOptions.tempSubxcriptionArr.push({ topic, onChange, options })
    return
  }
  // 判断订阅是否已存在
  const obj = defaultOptions.subscribeList.find((item) => item.topic === realTopic)
  if (!obj) {
    defaultOptions.subscribeList.push({ topic, onChange, options })
    // 订阅
    defaultOptions.client.subscribe(realTopic, { qos }, (error, res) => {
      if (error) {
        console.log(`Subscribe to ${topic} error`, error)
      } else {
        // console.log(`${topic},订阅成功,qos:${qos}`)
      }
    })
  }
}
const doUnSubscribe = (topic) => {
  defaultOptions.subscribeList = defaultOptions.subscribeList.filter((item) => item.topic !== topic)
  defaultOptions.client.unsubscribe(getPrefix() + topic, (error) => {
    if (error) {
      console.log('Unsubscribe error', error)
    }
  })
}

const destroyConnection = () => {
  defaultOptions.subscribeList = []
  if (defaultOptions.client.connected) {
    try {
      defaultOptions.client.end()
      defaultOptions.client = {
        connected: false
      }
    } catch (error) {
      console.log('Disconnect failed', error.toString())
    }
  }
}

const doPublish = (topic, payload) => {
  const { qos } = defaultOptions.publish
  if (!defaultOptions.client.connected) {
    createConnect()
  }
  defaultOptions.client.publish(getPrefix() + topic, payload, qos, (error) => {
    if (error) {
      console.log('Publish error', error)
    }
  })
}

function createConnect(topic, onSuccess, onChange, onError) {
  if (defaultOptions.client.connected) {
    return {
      topic,
      client: defaultOptions.client,
      doSubscribe,
      doUnSubscribe,
      doPublish,
      destroyConnection
    }
  }
  if (defaultOptions.loading) {
    // 处于连接中
    return
  }
  const { host, port, endpoint, ...options } = defaultOptions.connection
  const connectUrl = `wss://${host}${endpoint}`
  try {
    defaultOptions.client = mqtt.connect(connectUrl, options)
  } catch (error) {
    onError && onError(error)
  }
  defaultOptions.client.uuid = uuidv5()
  defaultOptions.client.on('connect', () => {
    // console.log('连接成功：', defaultOptions.connection.clientId)
    defaultOptions.loading = false
    // 重新订阅
    if (defaultOptions.tempSubxcriptionArr.length > 0) {
      defaultOptions.tempSubxcriptionArr.forEach((item) => {
        doSubscribe(item.topic, item.onChange, item.options)
      })
      defaultOptions.tempSubxcriptionArr = []
    }
    onSuccess && onSuccess(topic)
  })
  defaultOptions.client.on('error', (error) => {
    console.log('连接错误：', error)
    onError && onError(error)
  })
  defaultOptions.client.on('reconnect', () => {
    // console.log('重新连接：', defaultOptions.connection.clientId)
    defaultOptions.loading = true
  })
  defaultOptions.client.on('message', (topic, message) => {
    console.log('message监听：', topic)
    onChange && onChange(message, topic)
    const prefix = getPrefix() + ':'
    const oriTopic = topic.replace(prefix, '')
    const obj = defaultOptions.subscribeList.find((item) => item.topic === oriTopic)
    if (obj) {
      obj.onChange && obj.onChange(message, oriTopic)
    }
  })
  defaultOptions.client.on('close', () => {
    // console.log('连接关闭')
  })
  return {
    topic,
    client: defaultOptions.client,
    doSubscribe,
    doUnSubscribe,
    doPublish,
    destroyConnection
  }
}
const mqConnnect = () => {
  return {
    createConnect,
    doSubscribe,
    doUnSubscribe,
    doPublish,
    destroyConnection
  }
}
export default mqConnnect
export { mqConnnect }
